import React, { useEffect, useRef } from "react";
import FaExpandAni from "./FaExpandAni";
import RoughBorder from "../../kits/LayoutKit/RoughBorder";

export default function ModalWrapper({ children, onClose }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Scroll lock
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) onClose?.();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      onMouseDown={handleBackdropClick}
      className="fixed inset-0 z-[9999] grid place-items-center isolate"
    >
      <div
        aria-hidden="true"
        className="
          absolute inset-0
          bg-white/100
          backdrop-blur-2xl backdrop-saturate-150
        "
      />

      <div
        ref={modalRef}
        className="
          relative w-[95vw] max-w-3xl
          rounded-2xl shadow-2xl
          bg-gradient-to-br from-gray-50 via-white to-gray-100
        "
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-2 right-2 z-10"
          aria-label="Schließen"
        >
          <FaExpandAni />
        </button>

        <div className="pt-10 pb-6 px-6 sm:pt-12 sm:pb-8 sm:px-8">
          {children}
        </div>

        <RoughBorder
          parentRef={modalRef}
          radius={20}
          padding={2}
          color="#AC8E66"
          strokeWidth={0.3}
          roughness={1}
          bowing={2}
        />
      </div>
    </div>
  );
}
